// Dependency-free on purpose: the chat storage helpers need to clear the offline
// log without importing the logger, whose import chain (store, services) cycles
// back into the modules that write chat keys.
export const OFFLINE_LOGS_KEY = 'webapp-logs';

const clearListeners = new Set<() => void>();

/** Lets the logger drop its in-memory copy so it does not rewrite what was just cleared. */
export function onOfflineLogsCleared(listener: () => void): void {
    clearListeners.add(listener);
}

export function clearStoredLogs(): void {
    try {
        localStorage.removeItem(OFFLINE_LOGS_KEY);
    } catch {
        // storage unusable; nothing to free
    }
    clearListeners.forEach(listener => listener());
}
